<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 4.125H0V19.875H24V4.125Z" fill="#DA251D" />
  <path
    d="M12.1921 7.3129L13.2984 10.6316L16.7952 10.6598C16.9921 10.6598 17.0718 10.9129 16.9124 11.0254L14.0999 13.102L15.1546 16.4348C15.2155 16.6223 14.9999 16.777 14.8405 16.6598L11.9999 14.6301L9.1546 16.6645C8.99523 16.777 8.78429 16.6223 8.84054 16.4395L9.89523 13.1066L7.08273 11.0301C6.92335 10.9129 7.00773 10.6645 7.19992 10.6645L10.6968 10.6363L11.803 7.31758C11.8687 7.1254 12.1312 7.1254 12.1921 7.3129Z"
    fill="#FFFF00"
  />
</svg>
